<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('promotion.pageTitle'),
          href: '/admin/promotions',
        },
        {
          text: $t('edit'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1" :tab="$t('promotion.promotionPackage')">
              <PromotionPackageForm ref="PromotionPackageForm" />
            </a-tab-pane>
          </a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PromotionPackageForm from './components/promotion-package-form'

export default {
  name: 'promotionPackageEdit',
  components: {
    PromotionPackageForm
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('promotion/promotionPackage', ['find']),
    ...mapActions('promotion/resource', ['getBranch']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
      await this.setEditData()
      this.loading = false
    },
    async setEditData() {
      await this.find(this.$route.params.id)
        .then(() => {
          this.$refs.PromotionPackageForm.setEditData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/promotionPackage/SET_EDIT_DATA', {})
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>

<style></style>
